import { render } from "./Synchroniwation.vue?vue&type=template&id=328d1dc6&scoped=true"
import script from "./Synchroniwation.vue?vue&type=script&lang=js"
export * from "./Synchroniwation.vue?vue&type=script&lang=js"

import "./Synchroniwation.vue?vue&type=style&index=0&id=328d1dc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328d1dc6"]])

export default __exports__